import { invokeRPC } from './socket.js'

export const setSubdomain = (customerId, subdomain) => {
  return invokeRPC('subdomain', 'setSubdomain', {
    customer_id: customerId,
    subdomain: subdomain
  })
}

export const getSubdomain = (customerId) => {
  return invokeRPC('subdomain', 'getSubdomainForCustomer', { customer_id: customerId })
}